import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { CollaboratorFunction } from './types'

export const COLLABORATOR_FUNCTIONS_QUERY: TypedDocumentNode<
  { collaboratorFunctions: CollaboratorFunction[] },
  { clientId: string; applicationId: string; search?: string; limit?: number; offset?: number }
> = gql`
  query CollaboratorFunctions($clientId: ID!, $applicationId: ID!, $search: String, $limit: Int, $offset: Int) {
    collaboratorFunctions(clientId: $clientId, applicationId: $applicationId, search: $search, limit: $limit, offset: $offset) {
      id client_id application_id key name locked collaborators_count created_at updated_at
    }
  }
`

export const COLLABORATOR_FUNCTION_QUERY: TypedDocumentNode<
  { collaboratorFunction: CollaboratorFunction | null },
  { id: string }
> = gql`
  query CollaboratorFunction($id: ID!) {
    collaboratorFunction(id: $id) {
      id client_id application_id key name locked collaborators_count created_at updated_at
    }
  }
`
